"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var Breadcrumb_base_1 = require("./Breadcrumb.base");
var Breadcrumb_styles_1 = require("./Breadcrumb.styles");
exports.Breadcrumb = Utilities_1.styled(Breadcrumb_base_1.BreadcrumbBase, Breadcrumb_styles_1.getStyles);
//# sourceMappingURL=Breadcrumb.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/Breadcrumb/Breadcrumb.js
// module id = 1460
// module chunks = 0